import { render, staticRenderFns } from "./add_comment.vue?vue&type=template&id=30cda380&"
import script from "./add_comment.vue?vue&type=script&lang=js&"
export * from "./add_comment.vue?vue&type=script&lang=js&"
import style0 from "./add_comment.vue?vue&type=style&index=0&id=30cda380&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports